export const TIME = (
  seconds,
  setSeconds,
  cancel,
  countdown = false,
  forceEnd = null
) =>
  setTimeout(() => {
    if (forceEnd && seconds === 0) forceEnd();
    else !cancel && setSeconds(seconds + 1 * (countdown ? -1 : 1));
  }, 1000);

export const resolveTime = seconds => {
  let minutes = parseInt(seconds / 60),
    second = parseInt(seconds - minutes * 60);
  return `${minutes.toString().padStart(2, "0")}:${second
    .toString()
    .padStart(2, "0")}`;
};
